import { Button } from "@mantine/core";
import { usePostHog } from "posthog-js/react";
import {
  MIGRATION_BANNER_CTA_CLICKED,
  MIGRATION_FULLPAGE_CTA_CLICKED,
} from "../constants/posthogEvents";
import { openChat } from "../services/chatService";
import type { MigrationEntryPoint } from "../utils/smdMigrationInterception";
import styles from "./SmdMigrationSupportActions.module.css";

export const SMD_MIGRATION_SUPPORT_PHONE_DISPLAY = "(831) 318-3710";
export const SMD_MIGRATION_SUPPORT_PHONE_HREF = "tel:+18313183710";

const SmdMigrationSupportActions = ({
  placement,
  entryPoint,
  onCtaClick,
  testIdSuffix,
}: {
  placement: "banner" | "fullpage";
  entryPoint?: MigrationEntryPoint;
  onCtaClick?: () => void;
  testIdSuffix?: string;
}) => {
  const posthog = usePostHog();
  const eventName =
    placement === "banner"
      ? MIGRATION_BANNER_CTA_CLICKED
      : MIGRATION_FULLPAGE_CTA_CLICKED;

  const captureClick = (ctaType: "call" | "chat") => {
    onCtaClick?.();
    posthog.capture(eventName, {
      cta_type: ctaType,
      ...(entryPoint ? { entry_point: entryPoint } : {}),
    });
  };
  const testId = (ctaType: "call" | "chat") =>
    `migration-${placement}-${ctaType}${testIdSuffix ? `-${testIdSuffix}` : ""}`;

  return (
    <div className={styles.actions} data-placement={placement}>
      <Button
        component="a"
        className={styles.action}
        href={SMD_MIGRATION_SUPPORT_PHONE_HREF}
        onClick={() => captureClick("call")}
        data-testid={testId("call")}
        radius="xl"
        size="md"
      >
        Call {SMD_MIGRATION_SUPPORT_PHONE_DISPLAY}
      </Button>
      <Button
        className={`${styles.action} ${styles.secondary}`}
        type="button"
        variant="subtle"
        onClick={() => {
          captureClick("chat");
          openChat();
        }}
        data-testid={testId("chat")}
        radius="xl"
        size="md"
      >
        Chat with us
      </Button>
    </div>
  );
};

export default SmdMigrationSupportActions;
